export default "__VITE_ASSET__HcR$Ldkh__"